import { createWebHistory, createRouter } from "vue-router";

const BASE_TITLE = "Yayasan Beasiswa Trisakti";

const routes = [
  {
    path: '/berita',
    name: 'news',
    component: () => import('@/pages/news/index.vue'),
    meta: { title: 'Berita' },
  },
  {
    path: '/berita/:id',
    name: 'news-detail',
    component: () => import('@/pages/news/detail.vue'),
    meta: { title: 'Detail Berita' },
  },
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index/index.vue'),
    meta: { title: "Beranda" },
  },
  {
    path: "/tentang-kami",
    name: "tentang-kami",
    component: () => import('@/pages/tentang-kami/index.vue'),
    meta: { title: "Tentang Kami" },
  },
  {
    path: "/donor",
    name: "donor",
    component: () => import('@/pages/donor/index.vue'),
    meta: { title: "Donor" },
  },
  {
    path: "/beasiswa",
    name: "beasiswa",
    component: () => import('@/pages/beasiswa/index.vue'),
    meta: { title: "Beasiswa" },
  },
  {
    path: "/dampak",
    name: "dampak",
    component: () => import('@/pages/dampak/index.vue'),
    meta: { title: "Dampak" },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import('@/pages/contact/index.vue'),
    meta: { title: "Hubungi Kami" },
  },
  {
    path: '/program-detail/:id',
    name: 'ProgramDetail',
    component: () => import('@/pages/program/program-detail.vue'),
    meta: { title: "Detail Program" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

router.afterEach((to) => {
  const pageTitle = to.meta?.title;
  document.title = pageTitle ? `${pageTitle} | ${BASE_TITLE}` : BASE_TITLE;
});

export default router;